<template>
  <div class="menu" role="button" @click.stop="$emit('click')">
    <fluent-icon
      v-if="variant === 'icon' && option.icon"
      :icon="option.icon"
      size="14"
      class="menu-icon flex-shrink-0"
    />
    <span
      v-if="variant === 'label' && option.color"
      class="label-pill flex-shrink-0"
      :style="{ backgroundColor: option.color }"
    />
    <thumbnail
      v-if="variant === 'agent'"
      :username="option.label"
      :src="option.thumbnail"
      :status="option.status"
      size="20px"
      class="agent-thumbnail flex-shrink-0"
    />
    <p
      ref="labelEl"
      v-tooltip.top="truncationTooltip"
      class="menu-label overflow-hidden whitespace-nowrap text-ellipsis"
    >
      {{ option.label }}
    </p>
  </div>
</template>

<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      truncationTooltip: '',
      resizeObserver: null,
    };
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.$nextTick(() => this.syncTruncationTooltip());
      },
    },
  },
  mounted() {
    this.bindResizeObserver();
    this.$nextTick(() => this.syncTruncationTooltip());
  },
  beforeDestroy() {
    this.unbindResizeObserver();
  },
  methods: {
    bindResizeObserver() {
      if (typeof ResizeObserver === 'undefined') {
        return;
      }
      this.resizeObserver = new ResizeObserver(() => {
        this.syncTruncationTooltip();
      });
      this.$nextTick(() => {
        const el = this.$refs.labelEl;
        if (el) this.resizeObserver.observe(el);
      });
    },
    unbindResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
    syncTruncationTooltip() {
      const el = this.$refs.labelEl;
      const text = this.option.label;
      if (!el || text === undefined || text === null || text === '') {
        this.truncationTooltip = '';
        return;
      }
      const label = String(text);
      // +1 avoids false positives from sub-pixel rounding
      this.truncationTooltip = el.scrollWidth > el.clientWidth + 1 ? label : '';
    },
  },
};
</script>

<style scoped lang="scss">
.menu {
  width: calc(var(--space-mega) * 2);
  max-width: 100%;
  min-width: 0;
  @apply flex items-center flex-nowrap p-1 rounded-sm overflow-hidden cursor-pointer;

  .menu-label {
    @apply my-0 mx-2 text-xs min-w-0 flex-1;
  }

  &:hover {
    @apply bg-woot-500 dark:bg-woot-500 text-white dark:text-slate-50;
  }
}

.agent-thumbnail {
  margin-top: 0 !important;
}

.label-pill {
  @apply w-4 h-4 rounded-full border border-slate-50 border-solid dark:border-slate-900 flex-shrink-0;
}
</style>
